import { Component, Input, Output, EventEmitter } from '@angular/core';

import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'app-auto-complete-email',
  templateUrl: './auto-complete-email.component.html',
  styleUrls: ['./auto-complete-email.component.css']
})
export class AutoCompleteEmailComponent {
  suggestions: any[] = [];
  selectedIndex: number = -1;
  emailList: any[] = [];
  @Input("model") selectedTags: any[];
  @Input() dropDownList: any[];
  @Input("disable") disabled: any;
  @Input() searchText: any;
  @Output() modelChange = new EventEmitter<any[]>();

  constructor(private utilityService: UtilityService) { }

  search() {
    //Put search logic here
    if (this.searchText.length > 0) {
      var suggestions = [];
      this.emailList.forEach((email: any) => {
        if (email.EmailAddress.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 || email.DisplayName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1)
          suggestions.push(email);
      });
      this.suggestions = suggestions;
      if (this.suggestions.length == 0)
        this.selectedIndex = -1;
      else {
        if (this.selectedIndex == -1 || this.selectedIndex > this.suggestions.length) {
          this.selectedIndex = 0;
        }
      }
    } else
    this.suggestions = [];
  }

  checkKeyDown(event) {
    if (event.keyCode === 40) {//down key, increment selectedIndex
      event.preventDefault();
      if (this.selectedIndex + 1 !== this.suggestions.length) {
        this.selectedIndex++;
      }
    }
    else if (event.keyCode === 38) { //up key, decrement selectedIndex
      event.preventDefault();
      if (this.selectedIndex - 1 !== -1) {
        this.selectedIndex--;
      }
    }
    else if (event.keyCode === 13) { //enter pressed
      this.addToSelectedTags(this.selectedIndex);
    }
    else if (event.keyCode === 9) { //tab pressed
      this.addToSelectedTags(this.selectedIndex);
    }
  }

  addToSelectedTags(index) {
    if (this.selectedTags.indexOf(this.suggestions[index]) === -1) {
      if (index != -1) {
        this.selectedTags.push(this.suggestions[index]);
        this.searchText = '';
        this.suggestions = [];
      }
      else {
        if (this.utilityService.validateEmail(this.searchText)) {
          var newItem = { EmailAddress: this.searchText, DisplayName: this.searchText }
          this.selectedTags.push(newItem);
          this.modelChange.emit(this.selectedTags);
          this.searchText = '';
          this.suggestions = [];
        }
      }
    }
  }

  removeTag(index) {
    this.selectedTags.splice(index, 1);
  }

}